import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { STRAVA_CONFIG } from '../config';

const StravaCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleCallback = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            const error = urlParams.get('error');

            if (error) {
                console.error('Strava authorization error:', error);
                navigate('/');
                return;
            }

            if (!code) {
                console.error('No authorization code received');
                navigate('/');
                return;
            }

            try {
                console.log('Exchanging code for token...');
                const response = await axios.post(STRAVA_CONFIG.tokenUrl, {
                    client_id: STRAVA_CONFIG.clientId,
                    client_secret: STRAVA_CONFIG.clientSecret,
                    code: code,
                    grant_type: 'authorization_code'
                });

                console.log('Token exchange successful');
                
                // Store the access token and refresh token
                localStorage.setItem('stravaAccessToken', response.data.access_token);
                localStorage.setItem('stravaRefreshToken', response.data.refresh_token);
                localStorage.setItem('stravaAthlete', JSON.stringify(response.data.athlete));

                // Add a small delay before redirecting to ensure tokens are stored
                await new Promise(resolve => setTimeout(resolve, 1000));

                // Redirect to the main app
                navigate('/dashboard');
            } catch (error) {
                console.error('Error exchanging code for token:', error.response?.data || error.message);
                if (error.response?.data?.message) {
                    console.error('Strava error details:', error.response.data.message);
                }
                navigate('/');
            }
        };

        handleCallback();
    }, [navigate]);

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h2>Connecting to Strava...</h2>
            <p>Please wait while we complete the connection.</p>
        </div>
    );
};

export default StravaCallback; 